import { PERMISSIONS } from 'shared-permissions';

const { VOD_MANAGE, VOD_STATS, EDIT_USERS_VOD, WORKSPACE_SETTINGS, VOD_INTEGRATIONS } = PERMISSIONS;
import {
  ORG_ON_DEMAND_VIDEOS,
  ORG_ON_DEMAND_PRODUCTS,
  ORG_ON_DEMAND_DISTRIBUTION_PAGES,
  ORG_USERS,
  ORG_GENERAL_SETTINGS,
  ORG_ON_DEMAND_GET_STARTED,
  ORG_EMBED_STATS,
  ORG_ON_DEMAND_ACTIONS,
  ORG_ON_DEMAND_THEMES,
  ORG_INTEGRATIONS,
  ORG_ON_DEMAND_DATA_EXPORT_JOBS,
} from 'constants/routes.js';
import { playerV2Filter } from './utils.js';

const ON_DEMAND_ROUTES = [
  /*{
    title: 'sidebarComponent.homeTitle',
    icon: 'home',
    route: ORG_ON_DEMAND_HOME,
    requiredFeatures: ['productsNavigationEnabled'],
    requiredPermission: VOD_MANAGE,
    dataTestId: 'homeMenuItem',
    allowSuperAdmin: false,
    exact: true,
    shownInMasquerade: false,
  },*/
  {
    title: 'sidebarComponent.videosTitle',
    icon: 'videos',
    route: ORG_ON_DEMAND_VIDEOS,
    requiredFeatures: ['productsNavigationEnabled', 'vodEnabled'],
    requiredPermission: VOD_MANAGE,
    dataTestId: 'videosMenuItem',
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.productsTitle',
    icon: 'bag',
    route: ORG_ON_DEMAND_PRODUCTS,
    requiredFeatures: ['productsNavigationEnabled', 'vodEnabled'],
    requiredPermission: VOD_MANAGE,
    dataTestId: 'productsMenuItem',
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.actionsTitle',
    icon: 'actions',
    route: ORG_ON_DEMAND_ACTIONS,
    requiredFeatures: ['vodActionsEnabled', 'vodEnabled'],
    requiredPermission: VOD_MANAGE,
    dataTestId: 'productsMenuItem',
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.distributionsTitle',
    icon: 'playlist',
    route: ORG_ON_DEMAND_DISTRIBUTION_PAGES,
    requiredFeatures: ['productsNavigationEnabled', 'vodEnabled'],
    requiredPermission: VOD_MANAGE,
    dataTestId: 'playlistMenuItem',
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.statsEmbedTitle',
    icon: 'bulb',
    route: ORG_EMBED_STATS,
    requiredFeatures: ['productsNavigationEnabled', 'vodEnabled', 'vodStatsEmbedEnabled'],
    requiredPermission: VOD_STATS,
    dataTestId: 'statsEmbedMenuItem',
    allowSuperAdmin: true,
    customFilterFunction: ({ features }) => !features.dataExportEnabled,
  },
  {
    title: 'sidebarComponent.statsTitle',
    icon: 'insights',
    dataTestId: 'statsMenuItem',
    submenu: [
      {
        title: 'sidebarComponent.statsEmbedTitle',
        route: ORG_EMBED_STATS,
        requiredFeatures: ['productsNavigationEnabled', 'vodEnabled', 'vodStatsEmbedEnabled'],
        allowSuperAdmin: true,
        requiredPermission: VOD_STATS,
        dataTestId: 'statsEmbedMenuItem',
        flair: {
          id: 'sidebarFlair-sub-menu-insights',
        },
      },
      {
        title: 'sidebarComponent.dataExportJobsTitle',
        route: ORG_ON_DEMAND_DATA_EXPORT_JOBS,
        requiredFeatures: ['vodEnabled', 'dataExportEnabled'],
        allowSuperAdmin: true,
        requiredPermission: VOD_STATS,
      },
    ],
    customFilterFunction: ({ features }) => features.dataExportEnabled,
  },
  {
    title: 'sidebarComponent.settingsTitle',
    icon: 'settings',
    requiredFeatures: ['productsNavigationEnabled', 'vodEnabled'],
    requiredPermission: VOD_MANAGE,
    dataTestId: 'settingsMenuItem',
    allowSuperAdmin: true,
    align: 'bottom',
    submenu: [
      {
        title: 'sidebarComponent.generalSettingsTitle',
        route: ORG_GENERAL_SETTINGS,
        requiredFeatures: [],
        requiredPermission: WORKSPACE_SETTINGS,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.usersSettingsTitle',
        route: ORG_USERS,
        requiredFeatures: [],
        requiredPermission: EDIT_USERS_VOD,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.themingTitle',
        route: ORG_ON_DEMAND_THEMES,
        requiredFeatures: ['vodThemingEnabled'],
        requiredPermission: VOD_MANAGE,
        customFilterFunction: playerV2Filter,
        allowSuperAdmin: true,
      },
      {
        title: 'sidebarComponent.appIntegrationsTitle',
        route: ORG_INTEGRATIONS,
        requiredPermission: VOD_INTEGRATIONS,
        allowSuperAdmin: true,
      },
    ],
  },
  {
    title: 'sidebarComponent.gettingStartedTitle',
    icon: 'progress',
    requiredFeatures: ['productsNavigationEnabled', 'vodEnabled'],
    route: ORG_ON_DEMAND_GET_STARTED,
    requiredPermission: VOD_MANAGE,
    dataTestId: 'getStartedMenuItem',
    allowSuperAdmin: true,
  },
];

export default ON_DEMAND_ROUTES;
